export const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Auth/Login.vue'),
    meta: {
      title: 'Login | PourNow',
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/Auth/ForgotPassword.vue'),
    meta: {
      title: 'Forgot Password | PourNow',
    },
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import('@/views/Auth/PasswordReset.vue'),
    meta: {
      title: 'Reset Password | PourNow',
    },
  },
]
